import React from 'react';
import { Toast } from '../Toast/Toast';
import './ToastList.css';
export function ToastList(props) {
    const { toasts, mobile, removeCallback } = props;
    return (React.createElement(React.Fragment, null, toasts.map((toast) => (React.createElement(Toast, Object.assign({}, toast, { key: `${toast.name}_${toast.addedAt}`, mobile: mobile, removeCallback: () => removeCallback(toast.name) }))))));
}
